import React from "react";
import "./ProfileIcon.css";

// Small button used to open the profile modal.
export default function ProfileIcon({ onClick }) {
  return (
    <button type="button" className="cm-profile-icon-btn" onClick={onClick} aria-label="Profile" />
  );
}
